import { QRule } from "../CoreApp/QRule.js";

export function CreateIWizSubFilter(iWizData) {
  var doFilter = iWizData.GetFilterData();
  var theFilter = null;
  if (doFilter) {
    theFilter = new QRule();
    theFilter.InitRule(
      iWizData.GetFilterSubsOption(),
      iWizData.GetChainLevels(),
      iWizData.GetIncludeFiltered()
    );

    var isComplex = iWizData.GetComplexSubFilter();
    if (isComplex) {
      theFilter.SetIsComplex(true);
      var complexDef = iWizData.GetComplexSubFilterDef();
      theFilter.SetComplexDef(complexDef);
    }
  }

  return theFilter;
}
